<template>
  <div id="app">

   
    <snackbar v-if="isSnackbar" :message="message" :backgroundColor="backgroundColor"></snackbar>

    <Init class="body-min-width"></Init>
     <ScrollToTop />
      <!-- first time user language select homepage blocker -->
     <landingModal  v-if="appConfig.featureEnabled.hasDashboardEnable && firstTimeUser"  />
  </div>
</template>

<script>
import { eventBus } from "@/eventBus";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { store } from "@/store/store";
import { _fbId, _firebase, _providerId } from "./provider-config.js";

import FirebaseActions from "./mixins/FirebaseActions.js";

import firebase from "firebase/app";
import "firebase/auth";

import Utility from "./mixins/Utility";
import {setUserPropertiesFunc} from "@/utilities";

export default {
  mixins: [Utility, FirebaseActions],
  name: "App",
  data() {
    return {
      isSnackbar: null,
      message: "",
      backgroundColor: "",
      mobileWeb: false,
      mobileBrowserController: true,
      firstTimeUser: false,
    };
  },
  computed: {
    ...mapGetters(["subscriberid", "newSubscription", "newPurchase", "getDisplayLanguage", "getDisplayLanguageCode", "getCountryListByCode", "getPairingFlag"]),
  },
  watch: {
    '$i18n.locale'(newLang) {
      // Update the lang attribute on the <html> tag based on URL path
      this.updateHtmlLangAttribute();
    },
    $route(to, from) {
      console.log('Navigating to:', to.name);
      eventBus.$emit("closeLangPopup")
      this.landingRoutes(to);
      this.setupLandingUrl(to);
      // Update lang attribute when route changes
      this.updateHtmlLangAttribute();
      const subscriber = localStorage.getItem("subscriberDetails") ? localStorage.getItem("subscriberDetails") : "";
      if ((to.name === "Watchlist" || to.name === "Bold") && !subscriber) {
        this.$router.push({ name: "Home" });
      }
    },
    subscriberid(val) {
      this.fetchSubscriberList();
      this.fetchPurchaseList();

      if (val) {
        this.firebaseAnonymousLogin();

        this.setUserProfileDetails();
      }
    },
    newSubscription(val) {
      if (val) {
        //fetch subscription list after each subscription.
        this.fetchSubscriberList();
      } else if (!val) {
        console.log("subscription cancelled");
      }
    },
    newPurchase(val) {
      if (val) {
        //fetch purchase list after each purchase.
        this.fetchPurchaseList();
      }
    },
  },
  created() {
  
    // Check if user is offline
    this.checkOffline();

    // Check if user is offline
    this.checkOnline();

    // Check if the User is logged into firebase
    firebase.auth().onAuthStateChanged((user) => {
      if (user && user.uid) {
        this.setFirebaseUserUID(user.uid);
      }

      if (this.subscriberid && !user) {
        this.firebaseAnonymousLogin();
      }
    });

    const hasVisitedBefore = localStorage.getItem("hasVisitedBefore");
    
    if (!hasVisitedBefore) {
    this.firstTimeUser = true;
    localStorage.setItem("hasVisitedBefore", true);
  }

    // Detect browser.
    this.checkBrowser();
  },
  mounted() {
    // Set initial lang attribute based on URL path
    this.updateHtmlLangAttribute();
    this.actGetUTMData();
    document.body.style.position = ""


    if(this.subscriberid) {
      this.setUserProfileDetails();
    }

    eventBus.$on("re-login-success", () => {
      this.fetchSubscriberList();
    });

    // Updating locale based on localstorage value.

    eventBus.$on("check-local-storage", (data) => {
      this.$i18n.locale = data;
    });

    // Event listener for facebook sdk load.
    window.addEventListener("facebook-loaded", this.loadFacebookSdk);

    // if (screen.width < 576) {
    //   window.addEventListener("load", this.removeAddressBar());
    // }

    eventBus.$on("snackBarMessage", (payload) => {
      this.messagesSnackbar(payload);
    });

    // clevertap push notification setup
    // clevertap.notifications.push({
    //   titleText: "Would you like to receive Push Notifications?",
    //   bodyText:
    //     "We promise to only send you relevant content and give you updates on your transactions",
    //   okButtonText: "Sign me up!",
    //   rejectButtonText: "No thanks",
    //   okButtonColor: "#f28046",
    //   askAgainTimeInSeconds: "5"
    // });

    // this.checkScreenSize();

    this.getCountryList().then(response => {
      this.setCountryListByCode(response);
        this.setCountryCodesList(response);
    })

    const subscriber = localStorage.getItem("subscriberDetails") ? localStorage.getItem("subscriberDetails") : "";

    if (!subscriber && location.pathname.includes("/profile")) {
        window.storeAfterLoginPath = location.pathname;
        this.$router.push({ name: "Home" });      

        setTimeout(() => {
          eventBus.$emit("toggle-auth");

        }, 4000)

      }

  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreenSize());
    eventBus.$off("re-login-success");
  },
  methods: {

    ...mapMutations(["setNewSubscription", "setCurrentBrowser", "setRtl", "setFirebaseUserUID", "setProfileid", "setKidsMode", "setCountryListByCode", "setCountryCodesList", "setPairingFlag"]),
    ...mapActions(["listProfiles", "getCountryList"]),

    updateHtmlLangAttribute() {
      // Determine language from URL path
      const currentPath = window.location.pathname;
      
      // Check if URL contains /hi/ or starts with /hi
      if (currentPath.includes('/hi/') || currentPath === '/hi' || currentPath.startsWith('/hi?')) {
        document.documentElement.lang = 'hi';
      } else {
        // For all other URLs (including /en/, no prefix, or root), set to 'en'
        document.documentElement.lang = 'en';
      }
      
      // Add notranslate attributes to prevent Google from showing "Translate this page"
      document.documentElement.classList.add('notranslate');
      document.documentElement.setAttribute('translate', 'no');
      
      // Add meta tag if not already present
      if (!document.querySelector('meta[name="google"][content="notranslate"]')) {
        const metaTag = document.createElement('meta');
        metaTag.name = 'google';
        metaTag.content = 'notranslate';
        document.head.appendChild(metaTag);
      }
    },

setupLandingUrl (to) {
      let langInUrl = to.params.lang;
      let defaultLanguage =  localStorage.getItem("setDisplayLanguageCode") ? localStorage.getItem("setDisplayLanguageCode").includes('en') ? 'eng' : localStorage.getItem("setDisplayLanguageCode")  : window.PROVIDER_SETUP_CONFIG.defaultLanguage;
      if(langInUrl === undefined || langInUrl === null){
        localStorage.setItem("setDisplayLanguageCode", defaultLanguage);
         this.$i18n.locale = defaultLanguage;
         return;
      }
      if (to.params.lang) {
        let seletedLanguage = "en";
        if (to.params.lang === "ar") {
          seletedLanguage = "ara";
        }  else if (to.params.lang === "hi") {
          seletedLanguage = "hi";
        }
        localStorage.setItem("setDisplayLanguageCode", seletedLanguage);
         this.$i18n.locale = seletedLanguage == 'en' ? 'eng' : seletedLanguage;
        // eventBus.$emit("check-local-storage", seletedLanguage);
        this.setRtl(seletedLanguage == "en" ? false : true);
      }
    },
  
    setUserProfileDetails() {
      const localProfileId = localStorage.getItem("currentProfileId");
      const localSubscriberProfileDetails = localStorage.getItem("subscriberProfileDetails");

      if (!localProfileId && !localSubscriberProfileDetails) {
        this.listProfiles().then((profileResponse) => {
          if (profileResponse.data.reason) {
            // this.formError = this.$t(profileResponse.data.reason);
          } else {
  
            if (profileResponse.data.totalcount === 1) {
              localStorage.setItem("currentProfileId", profileResponse.data.data[0].profileid);
              localStorage.setItem("subscriberProfileDetails", JSON.stringify(profileResponse.data.data[0]));

              this.setProfileid(profileResponse.data.data[0].profileid);
              let kidsMode = profileResponse.data.data[0].profileid === "NO" ? false : true;
              this.setKidsMode(kidsMode);
            }
          }
        });
      }
    },

    actGetUTMData() {
      let utm_details_global = {};
      let utm_source = this.getParameterByName("utm_source");
      let utm_medium = this.getParameterByName("utm_medium");
      let utm_campaign = this.getParameterByName("utm_campaign");
      if (utm_source) {
        utm_details_global.utm_source = utm_source;
      }
      if (utm_source) {
        utm_details_global.utm_medium = utm_medium;
      }
      if (utm_source) {
        utm_details_global.utm_campaign = utm_campaign;
      }

      localStorage.setItem("utm_details_global", JSON.stringify(utm_details_global));
    },
    landingRoutes(route) {
      console.error(route)
      // assigning i18n locale.
      let routename = route.name;
     if (!localStorage.getItem("setDisplayLanguageCode")) {
        const userLang = navigator.language || navigator.userLanguage;
        let seletedLanguage = "eng";

        if (userLang.includes("ar")) {
          seletedLanguage = "ara";
        }
        //setting localstorage value with english.
        localStorage.setItem("setDisplayLanguageCode", seletedLanguage);
        //Initially setting the application locale to english.
        this.$i18n.locale = seletedLanguage;
        eventBus.$emit("check-local-storage", seletedLanguage);
        this.setRtl(seletedLanguage == "eng" ? false : true);
      } else if (localStorage.getItem("setDisplayLanguageCode")) {
        this.$i18n.locale = localStorage.getItem("setDisplayLanguageCode") == 'en' ? 'eng' : localStorage.getItem("setDisplayLanguageCode");
      }

      let langInRoute = route.params.lang;
      let defaultLanguage = window.PROVIDER_SETUP_CONFIG.defaultLanguage;
      let supportedLocales = window.PROVIDER_SETUP_CONFIG.supportLanguageList;
   
      if (location.pathname == '/') {
          let currentLocale = localStorage.getItem("setDisplayLanguageCode");
          if(currentLocale !== defaultLanguage){
            if(currentLocale !== 'en' && defaultLanguage !== 'eng'){
							if(this.getPairingFlag) {

								this.$router.push({ name: "loginWithPinView"});
								}else {
								this.$router.replace({ name: "Home", params: { lang: currentLocale}});
								}
              return;
            }
          }
          if(langInRoute === undefined || langInRoute === null){
            return;
          }
          
          // if (this.getPairingFlag) {
			    //   this.$router.push({ name: "loginWithPinView"});
          // } else {
          //   this.$router.replace({ name: "Home", params: { lang: this.$i18n.locale == 'mr' ? 'mr' : null}});
          // }
          this.$router.replace({ name: "Home", params: { lang: this.$i18n.locale == 'hi' ? 'hi' : 'en'}});
        }
      if(langInRoute !== undefined && langInRoute !== null) {
        if(!supportedLocales.includes(langInRoute)){
          //render page not found
          this.$router.push({ name: "ErrorPage",});
          return;
        }
      }
    
    },
    checkBrowser() {
      // Get the user-agent string
      let userAgentString = navigator.userAgent;

      //detect chrome
      let chromeAgent = userAgentString.indexOf("Chrome") > -1;
      let firefoxAgent = userAgentString.indexOf("Firefox") > -1;

      switch (true) {
        case chromeAgent:
          this.setCurrentBrowser("Chrome");
          break;
        case firefoxAgent:
          this.setCurrentBrowser("Firefox");
          break;
      }
    },
    checkOffline() {
      window.addEventListener("offline", () => {
        this.isSnackbar = true;
        this.message = "You are offline,Please check your connectivity";
        this.backgroundColor = "$clr-offline-snackbar-bg";
        setTimeout(() => {
          this.isSnackbar = false;
        }, 2000);
      });
    },
    checkOnline() {
      window.addEventListener("online", () => {
        this.isSnackbar = true;
        this.message = "Back to Online";
        this.backgroundColor = "$clr-online-snbackbar-bg";
        setTimeout(() => {
          this.isSnackbar = false;
        }, 2000);
      });
    },
    messagesSnackbar(response) {
      this.isSnackbar = response.state;
      this.message = response.message;
      this.backgroundColor = response.color;
      setTimeout(() => {
        this.isSnackbar = false;
      }, 5000);
    },
    fetchSubscriberList() {
      let payload = {
        subscriptionstatus: "ALL",
      };

      let subscriberDetails = localStorage.getItem("subscriberDetails");

      if (subscriberDetails) {
        subscriberDetails = JSON.parse(subscriberDetails).data;
      } 

      store.dispatch("listSubscription", payload).then((response) => {
        if (!response.data.reason) {
          store.commit("setSubscriptionList", response.data.data);
          store.commit("setIsManageCards", true);
          this.setNewSubscription(false);
          this.fetchHighestDate(response.data.data);

          localStorage.setItem("subscriptionDetails", JSON.stringify(response.data.data[0]));
          setUserPropertiesFunc(subscriberDetails, response.data.data[0]);
        } 
      });
    },
    fetchPurchaseList() {
      store
        .dispatch("listPurchases")
        .then((response) => {
          if (!response.data.reason) {
            store.commit("setPurchasesList", response.data.data);
          }
        })
        .catch((error) => console.log(error));
    },
    fetchHighestDate(list) {
      let longExpiry = null;
      let planid = null;

      list.forEach((element) => {
        let date = new Date(element.nextbilling);
        //Initially storing first element to longExpiry.
        if (!longExpiry) {
          longExpiry = date;
          planid = element.planid;
        }
        //checking the highest date.
        if (date > longExpiry) {
          planid = element.planid;
        }
      });
      let index = list.findIndex((el) => {
        return el.planid === planid;
      });
      if (index > -1) {
        let item = list[index];
        // cleverTap profile push updating subscription start and end date.
        // clevertap.profile.push({
        //   Site: {
        //     SubscriptionStartDate: item.planstartdate,
        //     SubscriptionEndDate: item.nextbilling,
        //     SubscriptionStatus: "Paid"
        //   }
        // });
      }
    },
    loadFacebookSdk() {
      window.fbAsyncInit = function() {
        FB.init({
          appId: _fbId,
          autoLogAppEvents: true,
          xfbml: false,
          version: "v17.0",
        });
      };
      (function(d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.async = true;
        js.src = "//connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      })(document, "script", "facebook-jssdk");
    },
    checkScreenSize() {
      window.addEventListener("resize", () => {        
        eventBus.$emit("re-render-carousel", true);
      });
    },
    getParameterByName(name) {
      name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      let regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
      return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    },
  },
  components: {
    Init: () => import(/* webpackChunkName: "header - init" */ "@/components/Init/Init.vue"),
    snackbar: () => import("@/components/snackbar/Snackbar.vue"),
    ScrollToTop: () => import("@/components/utils/BackToTop.vue"),
    // languageModel: () => import("@/components/Language/LanguageModel.vue"),
    // landingModal: () => import("@/components/Language/LandingModel.vue"),
  },

};
</script>

<style lang="scss">
@import "./App.scss"
</style>
